import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Link,
  useParams,
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import { UserForm } from "../Form";
import { ChangingPassword } from "./ChangingPassword";
import Swal from "sweetalert2";
import { GrantingPermission } from "../GrantingPermission";
import PageNotFound from "../../notfound";

export const UpdateUser = () => {
  const navigate = useNavigate();
  const inputList = [
    {
      label: "Họ tên nhân viên",
      required: true,
      key: "fullname",
    },
    {
      label: "Tên đăng nhập",
      required: true,
      key: "username",
      // readonly: true,
    },
    { label: "Email", key: "email" },
    { label: "Số điện thoại", key: "phone" },
    { label: "Địa chỉ", key: "address" },
    { label: "Ghi chú", key: "note" },
  ];
  const TABS = {
    i: "info",
    c: "changePassword",
    g: "grantPermission",
    info: "i",
    changePassword: "c",
    grantPermission: "g",
  };
  const Links = [
    { to: "./?tab=i", content: "Cập nhật", key: "info" },
    { to: "./?tab=c", content: "Đổi mật khẩu", key: "changePassword" },
    { to: "./?tab=g", content: "Cấp quyền quản lý", key: "grantPermission" },
  ];

  const { username } = useParams();
  const _token = localStorage.getItem("_token");
  const { proxy, auth, lang } = useSelector((s) => s);
  const [isFetching, setIsFetching] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = TABS[searchParams.get("tab")] || "info";
  const [userInfo, setUserInfo] = useState({});
  const [refresh, setRefresh] = useState(0);
  const [selectedValues, setSelectedValues] = useState({
    plants: [],
    lines: [],
  });

  const handleUpdate = async () => {
    const response = await fetch(`${proxy()}/auth/v2/user/${username}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${_token}`,
      },
      body: JSON.stringify(userInfo),
    });
    const result = await response.json();
    const { success, message } = result;
    Swal.fire({
      title: success ? lang["success.update"] : lang["fail.update"],
      text: lang[message],
      icon: success ? "success" : "error",
      showConfirmButton: false,
      timer: 1500,
    }).then(() => setRefresh((prev) => prev + 1));
  };

  useEffect(() => {
    if (selectedValues?.storages) {
      setUserInfo((prev) => {
        const storages =
          [
            ...new Set(
              selectedValues?.storages?.map(
                (item) => item?.["7MKV"] || item?.KV?.["7MKV"]
              )
            ),
          ] || [];

        const warehouses =
          [...new Set(selectedValues?.storages?.map(({ value }) => value))] ||
          [];
        return {
          ...prev,
          warehouses,
          storages,
        };
      });
    }
  }, [selectedValues]);

  const Components = {
    info: (
      <UserForm
        key={refresh}
        action_btn="Cập nhật"
        user={userInfo}
        onChange={(payload) => {
          setUserInfo((prev) => ({ ...prev, ...payload }));
        }}
        cb={async (payload) => {
          handleUpdate();
        }}
        inputList={inputList}
        isAdd={false}
      />
    ),
    changePassword: <ChangingPassword />,
    grantPermission: (
      <GrantingPermission
        key={refresh}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        value={userInfo?.storages}
        privilegeGroupsValue={userInfo?.privilegeGroup}
        onChange={(payload) => {
          if (payload.key === "privilegeGroup") {
            setUserInfo((prev) => ({ ...prev, [payload.key]: payload.value }));
            return;
          }
          setUserInfo((prev) => {
            const storages = [
              ...new Set(
                selectedValues?.storages?.map(
                  (item) => item?.["7MKV"] || item?.KV?.["7MKV"]
                )
              ),
            ];

            const warehouses = [
              ...new Set(selectedValues?.storages.map(({ value }) => value)),
            ];
            return {
              ...prev,
              warehouses,
              storages,
            };
          });
        }}
        isAdd={false}
        handleUpdate={handleUpdate}
        userInfo={userInfo}
      />
    ),
  };

  useEffect(() => {
    (async () => {
      const response = await fetch(`${proxy()}/auth/v2/u/${username}`, {
        headers: { Authorization: _token },
      });
      const result = await response.json();
      switch (response?.status) {
        case 200:
          const { user } = result;
          setUserInfo(user);
          setSelectedValues({
            plantsView: [
              ...new Map(
                user?.storages.map((item) => [
                  item?.["7MKV"],
                  {
                    label: item?.["2TKV"],
                    value: item?.["7MKV"],
                  },
                ])
              ).values(),
            ],
            // plants: user?.plants,
            storagesView: user?.storages?.map((line) => ({
              ...line,
              label: [line["4TK"], line["8LK"]].filter(Boolean).join("|"),
              value: line.value,
            })),
            storages: user?.storages?.map((line) => ({
              ...line,
              label: [line["4TK"], line["8LK"]].filter(Boolean).join("|"),
              value: line.value,
            })),
          });
          break;
        case 400:
          Swal.fire({
            title: lang["error"],
            text: lang[result.message],
            icon: "error",
            showConfirmButton: true,
            // timer: 1500,
          }).then((res) => {
            if (res.isConfirmed) {
              navigate(-1);
            }
          });
          break;
      }
      setIsFetching(false);
    })();
  }, []);

  if (
    !["uad", "pm"].includes(auth?.role) &&
    !auth?.ct?.find(
      ({ table_alias, update }) => table_alias === "accounts" && update
    )
  ) {
    return <PageNotFound />;
  }

  if (isFetching) {
    return (
      <div
        className="w-100 d-flex justify-content-center align-items-center"
        style={{
          height: "80vh",
        }}
      >
        <img
          width={45}
          className="mb-1"
          src="/images/icon/load.gif"
          alt="Loading..."
        />
      </div>
    );
  }

  return (
    // <section>
    //   <p>
    //     <Link to="/users">Quản lý nhân viên</Link> {">>"} Chỉnh sửa nhân viên{" "}
    //     {username}
    //   </p>
    //   <section>
    //     {Links.map(({ to, content }, i) => (
    //       <Link to={to}>{content}</Link>
    //     ))}
    //   </section>
    //   {Components[tab]}
    // </section>
    <div className="container-fluid">
      <div className="page_title">
        <h4>Quản lý tài khoản</h4>
      </div>
      <div
        className="content"
        style={{
          marginLeft: "-15px",
          marginRight: "-15px",
        }}
      >
        <div
          className="white_shd full d-flex flex-column"
          style={{
            height: "84.5vh",
          }}
        >
          <div
            className="full graph_head"
            style={{
              borderBottom: "1px solid rgb(221, 221, 221)",
            }}
          >
            <div
              className="heading1 margin_0"
              onClick={() => navigate("/users")}
            >
              <h5>
                <label className="pointer m-0">
                  <a>
                    <i className="fa fa-chevron-circle-left mr-1 nav-item nav-link"></i>
                  </a>
                  <span>Quản lý tài khoản</span>
                  <i className="fa fa-chevron-right ml-2 mr-1 "></i>
                  {lang["edit"]}
                </label>
              </h5>
            </div>
          </div>
          <div
            className="navbar_container mt-2"
            style={{
              borderBottom: "1px solid #ddd",
              padding: "10px 15px",
            }}
          >
            <ul className="navbar_list d-flex">
              {Links.map(({ to, content, key }, i) => (
                <li className="navbar_item">
                  <Link
                    to={to}
                    className={`font-weight-bold item ${tab ? "active" : ""}`}
                    key={key}
                    style={{
                      padding: "10px 15px",
                      // color: tab === key && "#0066cc",
                      border: tab === key && "1px solid #ddd",
                      borderBottomColor: tab === key && "#00000000",
                      backgroundColor: tab === key && "#fff",
                    }}
                  >
                    {content}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div
            className="mt-4"
            style={{
              height: "70vh",
              overflow: "auto",
            }}
          >
            {Components[tab]}
          </div>
        </div>
      </div>
    </div>
  );
};
